export default "__VITE_ASSET__D34N$QYD__"